import { Icon } from '@petsmart-ui/sparky';
import { useEffect, useState } from 'react';
import { USER_DATA_KEY } from '@/constants';
import type { UserData } from '@/types';
import { UserMenuDrawer } from './UserMenuDrawer';
import './userMenu.scss';
const componentClassName = 'user-menu';
export function UserMenu() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [userName, setUserName] = useState('');
  useEffect(() => {
    const storedUserData = localStorage.getItem(USER_DATA_KEY);
    if (storedUserData) {
      try {
        const parsedUserData: UserData = JSON.parse(storedUserData);
        setUserName(parsedUserData.name || parsedUserData.email || '');
      } catch (error) {
        console.error('Failed to parse user data from localStorage:', error);
        setUserName('');
      }
    } else {
      setUserName('');
    }
  }, []);
  const handleDrawerOpen = () => setIsDrawerOpen(true);
  const handleDrawerClose = () => setIsDrawerOpen(false);
  return <>
            <button className={componentClassName} onClick={handleDrawerOpen}>
                <span className={`${componentClassName}-greeting`}>{userName ? `Hi, ${userName}` : ''}</span>
                <Icon className={`${componentClassName}-icon`} name="account-circle-outline" size="md" />
            </button>
            <UserMenuDrawer isActive={isDrawerOpen} handleClose={handleDrawerClose} />
        </>;
}